<template>
  <div class="productionProcess-print__head">
    <div class="head__title">{{info.brandVal}}工艺单</div>
    <div class="head__list">
      <div class="head__list-item">款号：{{info.materialCode}}</div>
      <div class="head__list-item">款式：{{info.materialDesc}}</div>
      <div class="head__list-item">组别：{{info.waveCode}}</div>
      <div class="head__list-item" style="width: 50mm">工厂：{{info.factoryDesc}}</div>
      <div class="head__list-item">单据状态：{{info.status == '2' ? '审核' : '未审核'}}</div>
    </div>
  </div>
</template>

<script>
import { formatImgUrl } from "src/filter/modules/img";

export default {
  name: "print-head",
  filters: {},
  props: {
    info: {
      type: Object,
      default: () => ({})
    },
    isWoollen: {
      type: Boolean,
      default: false
    }
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
@import "src/sass/index";
@import "src/sass/modules/mixin";
$_normal_font: 3.2mm;
$_title_font: 5mm;
$box_width: 190mm;
$box_height: 277mm;
$_black: #333;
// 标题部分
.productionProcess-print__head {
  width: 100%;
  height: 17mm;
  .head__title {
    padding-top: 10px;
    font-size: 6mm;
    font-weight: bold;
    text-align: center;
  }
  .head__list {
    font-size: $_normal_font;
    @include flex_center(space-around, center);
  }
}
</style>
